'use strict';

var jsxRuntime = require('react/jsx-runtime');
var React = require('react');
var components = require('@storybook/components');
var managerApi = require('@storybook/manager-api');
var constants = require('./constants.cjs');

function _interopNamespaceDefault(e) {
  var n = Object.create(null);
  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function () { return e[k]; }
        });
      }
    });
  }
  n.default = e;
  return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespaceDefault(React);

const MoonIcon = () => /* @__PURE__ */ jsxRuntime.jsx("svg", { viewBox: "0 0 24 24", focusable: "false", children: /* @__PURE__ */ jsxRuntime.jsx(
  "path",
  {
    fill: "currentColor",
    d: "M21.4,13.7C20.6,13.9,19.8,14,19,14c-5,0-9-4-9-9c0-0.8,0.1-1.6,0.3-2.4c0.1-0.3,0-0.7-0.3-1 c-0.3-0.3-0.6-0.4-1-0.3C4.3,2.7,1,7.1,1,12c0,6.1,4.9,11,11,11c4.9,0,9.3-3.3,10.6-8.1c0.1-0.3,0-0.7-0.3-1 C22.1,13.7,21.7,13.6,21.4,13.7z"
  }
) });
const SunIcon = () => /* @__PURE__ */ jsxRuntime.jsx("svg", { viewBox: "0 0 24 24", focusable: "false", children: /* @__PURE__ */ jsxRuntime.jsxs(
  "g",
  {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: "2",
    fill: "none",
    stroke: "currentColor",
    children: [
      /* @__PURE__ */ jsxRuntime.jsx("circle", { cx: "12", cy: "12", r: "5" }),
      /* @__PURE__ */ jsxRuntime.jsx("path", { d: "M12 1v2" }),
      /* @__PURE__ */ jsxRuntime.jsx("path", { d: "M12 21v2" }),
      /* @__PURE__ */ jsxRuntime.jsx("path", { d: "M4.22 4.22l1.42 1.42" }),
      /* @__PURE__ */ jsxRuntime.jsx("path", { d: "M18.36 18.36l1.42 1.42" }),
      /* @__PURE__ */ jsxRuntime.jsx("path", { d: "M1 12h2" }),
      /* @__PURE__ */ jsxRuntime.jsx("path", { d: "M21 12h2" }),
      /* @__PURE__ */ jsxRuntime.jsx("path", { d: "M4.22 19.78l1.42-1.42" }),
      /* @__PURE__ */ jsxRuntime.jsx("path", { d: "M18.36 5.64l1.42-1.42" })
    ]
  }
) });
const ColorModeTool = () => {
  const isDarkMode = localStorage.getItem("chakra-ui-color-mode") === "dark";
  const [darkMode, setDarkMode] = React__namespace.useState(isDarkMode);
  const channel = managerApi.addons.getChannel();
  const handleToggle = () => {
    channel.emit(constants.EVENTS.TOGGLE_COLOR_MODE, !darkMode ? "dark" : "light");
    setDarkMode((prev) => !prev);
  };
  return /* @__PURE__ */ jsxRuntime.jsx(
    components.IconButton,
    {
      title: `Set color mode to ${darkMode ? "light" : "dark"}`,
      active: darkMode,
      onClick: handleToggle,
      children: darkMode ? /* @__PURE__ */ jsxRuntime.jsx(SunIcon, {}) : /* @__PURE__ */ jsxRuntime.jsx(MoonIcon, {})
    }
  );
};

exports.ColorModeTool = ColorModeTool;
